import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exieFullScreen",
  "use": "icon-exieFullScreen-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-exieFullScreen\"><defs><style>#icon-exieFullScreen .cls-1{fill:#231815;}</style></defs><title>退出全屏</title><path class=\"cls-1\" d=\"M7,12.47a.9.9,0,0,0-.34-.07H2.5a.9.9,0,1,0,0,1.8h2L.26,18.46a.9.9,0,1,0,1.27,1.27L5.8,15.47v2a.9.9,0,1,0,1.8,0V13.3A.9.9,0,0,0,7,12.47Z\" /><path class=\"cls-1\" d=\"M6.7,1.6a.9.9,0,0,0-.9.9v2L1.54.26A.9.9,0,0,0,.26,1.54L4.53,5.8h-2a.9.9,0,1,0,0,1.8H6.7a.9.9,0,0,0,.9-.9V2.5A.9.9,0,0,0,6.7,1.6Z\" /><path class=\"cls-1\" d=\"M13,7.53a.9.9,0,0,0,.34.07h4.2a.9.9,0,1,0,0-1.8h-2l4.26-4.26A.9.9,0,0,0,18.46.26L14.2,4.53v-2a.9.9,0,0,0-1.8,0V6.7a.9.9,0,0,0,.56.83Z\" /><path class=\"cls-1\" d=\"M15.47,14.2h2a.9.9,0,1,0,0-1.8H13.3a.9.9,0,0,0-.9.9v4.2a.9.9,0,1,0,1.8,0v-2l4.26,4.26a.9.9,0,0,0,1.27-1.27Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/exieFullScreen.svg
// module id = mK9N
// module chunks = 54